export default __webpack_public_path__ + "static/media/covid.e8052976.jpeg";